import { defineMessages } from "react-intl";

import {
	stageMessages,
	validator
} from "lib/build/forms/htx/current-cardiological-state/nyha";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	nyha: {
		id: "form.nyha",
		defaultMessage: "NYHA"
	},
	stage: {
		id: "form.nyha.stage",
		defaultMessage: "Stádium"
	}
});

const fields: { [key: string]: FieldData } = {
	stage: {
		type: "field",
		path: ["stage"],
		label: messages.stage,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: stageMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.stage }] }]
};

export const node: LeafNode = {
	id: "nyha",
	value: {
		title: messages.nyha,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
